module.exports = __webpack_public_path__ + "static/media/arrow_down_blue.13a163af.svg";